import { Seo } from "@/components/layout/Seo";
import { PageHero } from "@/components/sections/PageHero";
import { SectionIntro } from "@/components/sections/SectionIntro";
import { OfferingGrid } from "@/components/sections/OfferingGrid";
import { ImageFeature } from "@/components/sections/ImageFeature";
import { CtaBand } from "@/components/sections/CtaBand";
import { Marquee } from "@/components/motion/Marquee";
import { PROGRAMMES } from "@/content/offerings";
import { enquire } from "@/content/navigation";

export default function Academy() {
  return (
    <>
      <Seo title="VION AI Academy | Practical AI, Cloud & Technology Training" description="VION AI Academy provides practical, career-focused training in AI, Generative AI, prompt engineering, automation, AI agents, cloud, DevOps and digital skills." path="/ai-academy" />
      <PageHero
        testid="academy-hero"
        eyebrow="VION AI Academy"
        lines={["Learn the", "Technologies Shaping", "the Future."]}
        accentLine={2}
        intro="VION AI Academy provides practical, accessible and career-focused training designed to help individuals, professionals, businesses and young people develop relevant technology skills."
        image="/images/academy-hero.webp"
        alt="African professionals learning together with laptops in a technology training session"
        actions={[
          { label: "Join a Programme", to: enquire("VION AI Academy"), testid: "academy-join-btn" },
          { label: "Request Corporate Training", to: enquire("Corporate Training"), variant: "outline", testid: "academy-corporate-btn" },
        ]}
      />
      <section className="bg-ink py-24 sm:py-32" data-testid="academy-programmes">
        <div className="shell">
          <SectionIntro eyebrow="Programmes" title={<>Nine pathways into <span className="italic text-gold-metal">modern technology.</span></>}>
            <p>Programme schedules and formats will be announced. Register your interest and we'll keep you informed.</p>
          </SectionIntro>
          <div className="mt-16">
            <OfferingGrid items={PROGRAMMES} prefix="programme" ctaLabel="Learn More" ctaHref={(p) => enquire("VION AI Academy", p.title)} />
          </div>
        </div>
      </section>
      <Marquee words={["Prompt Engineering", "AI Agents", "Cloud & DevOps", "Generative AI", "Digital Skills", "AI Automation"]} tone="light" />
      <ImageFeature
        testid="academy-corporate"
        image="/images/academy-2.webp"
        alt="Young African learners working through a technology course on laptops"
        eyebrow="For Organisations"
        title="Corporate AI training, designed around your team."
        text={["We work with organisations to design practical AI and technology training that fits their people, goals and ways of working.", "From AI literacy to automation and cloud skills, training focuses on real-world application and responsible adoption."]}
        actions={[
          { label: "Request Corporate Training", to: enquire("Corporate Training"), testid: "academy-feature-corporate-btn" },
          { label: "Join a Programme", to: enquire("VION AI Academy"), variant: "outlineDark", testid: "academy-feature-join-btn" },
        ]}
      />
      <CtaBand testid="academy-cta" eyebrow="Start Learning" title="Build skills that matter." text="Tell us what you'd like to learn and we'll guide you to the right programme." primary={{ label: "Join a Programme", to: enquire("VION AI Academy") }} secondary={{ label: "Request Corporate Training", to: enquire("Corporate Training") }} />
    </>
  );
}
